export const _APIS = {
	PRODUCT_PRICE: {
		CAR_MODEL_PRICE: {
			SEARCH: '/rental/scm/price/list',
			EDIT: '/rental/scm/price/up',
			VIEW: '/rental/scm/price/detail',
			PROD_BATCH_EDIT: '/rental/scm/price/upBatch',
			RULE_LIST: '/rental/scm/rule/list',
			PRICE_LIST_ALL: '/rental/scm/price/listAll',
		},
		VALUE_ADDED_PRICE: {
			SEARCH: '/rental/scm/rule/guarantee/list',
			ADD: '/rental/scm/rule/guarantee/add',
			EDIT: '/rental/scm/rule/guarantee/update',
			VIEW: '/rental/scm/rule/guarantee/detail',
			DELETE: '/rental/scm/rule/guarantee/delete',
		},
		BOOKING_RULE: {
			SEARCH: '/rental/scm/rule/policy/list',
			ADD: '/rental/scm/rule/policy/add',
			EDIT: '/rental/scm/rule/policy/update',
			VIEW: '/rental/scm/rule/policy/detail',
			DELETE: '/rental/scm/rule/policy/delete',
		},
		SERVICE_POLICY: {
			SEARCH: '/rental/scm/rule/serve/list',
			ADD: '/rental/scm/rule/serve/add',
			EDIT: '/rental/scm/rule/serve/update',
			VIEW: '/rental/scm/rule/serve/detail',
			DELETE: '/rental/scm/rule/serve/delete',
			CITY_LIST: '/rental/scm/district/assembleList',
		},
		CANCEL_RULE: {
			SEARCH: '/rental/scm/rule/cancel/list',
			ADD: '/rental/scm/rule/cancel/add',
			EDIT: '/rental/scm/rule/cancel/update',
			VIEW: '/rental/scm/rule/cancel/detail',
			DELETE: '/rental/scm/rule/cancel/delete',
			INIT: '/rental/scm/rule/cancel/init',
		},
		COMMON: {
			CONFIG: '/rental/scm/getSaasApolloConfig',
			C_HOLIDAYS: '/rental/scm/action/getHolidayConfig',
		},
	},
	ORDER_MANAGEMENT: {
		// TODO 确认实际接口位置
		ORDER_LIST: {
			SEARCH: '/rental/scm/order/list',
			DETAIL: '/rental/scm/order/detail',
			ARRANGE_CHANGE: '/rental/scm/order/detail',
			UPDATE_RENEWAL: '/rental/scm/order/renewal/update',
			FEE_RENEW: '/rental/scm/order/detail',
			DEDUCT: '/rental/scm/deposit/deduct', // 押金扣款
			ORDER_REFUND: '/rental/scm/order/refund', // 订单退款
			DEDUCT_REFUND: '/rental/scm/deposit/deduct/refund', // 押金扣款后退款
			DEDUCT_REVERT: '/rental/scm/deposit/deduct/revert', // 押金扣款撤回
			UNFREEZING: '/rental/scm/deposit/unfreeze', // 解冻
			REMARK: '/rental/scm/order/remark/add', // 备注
			ARRANGE_CAR: '/rental/scm/order/arrange/vehicle', // 排车
			ARRANGE_DRIVER: '/rental/scm/order/arrange/driver', // 排司机
			FREE_RENEWAL: '/rental/scm/order/renewal/freeRenewal', // 免费续租
			RENEWAL_DETAIL: '/rental/scm/order/renewal/detail', // 续租详情
			RENEWAL_AGREE: '/rental/scm/order/renewal/agree', // 续租同意
			RENEWAL_REJECT: '/rental/scm/order/renewal/reject', // 续租拒绝
			GET_CAR_MODEL_DETAIL: '/rental/scm/vehicle/storeVehicleDetail', // 车型详情信息
			GET_VEH_LIST_BY_ORDER_ID: '/rental/scm/order/veh/list', // 车型详情信息
			SEND_LINK: '/rental/scm/order/pickup/contract/getSignLink',
			SEND_CONTRACT: '/rental/scm/order/pickup/contract/send',
			PICKUP_SUCCESS: '/rental/scm/order/pickup/success',
			CONTRACT_STATUS: '/rental/scm/order/pickup/contract/getStatus',
		},
	},
	NOTIFICATION: {
		NOTIFICATION_LIST: {
			SEARCH: '/rental/scm/msg/list/page',
			READ: '/rental/scm/msg/read',
			POLLING_MSG: '/rental/scm/msg/list/count',
			READ_ALL: '/rental/scm/msg/readAll',
			READ_LATER: '/rental/scm/msg/readAfter',
		},
		CS_ORDER_LIST: {
			SEARCH: '/rental/scm/case/list', // 表格查询
			DETAIL: '/rental/scm/case/detail', // 工单详情
			REPLY: '/rental/scm/case/reply' // 工单回复
		}
	},
	SUPPLIER_ENTRY: {
		MIN_CITY_LIST: '/rental/scm/supplier/city',
		GET_CONTRACT: '/rental/scm/supplier/previewContract',
		GET_VERIFY_CODE: '/rental/scm/supplier/verifyCode',
		CONFIRM_SIGN_CONTRACT:'/rental/scm/supplier/signContract',
		BANK_LIST: '/rental/scm/supplier/bankList',
		BRANCH_BANK_LIST: '/rental/scm/supplier/branchBankList',
		AGREEMENT_SIGN: '/rental/scm/supplier/agreementSign',
		BASIC_SAVE: '/rental/scm/supplier/basicSave',
		SUPPLIER_INFO:'/rental/scm/supplier/getInfo',
		BANK_CHANEL_LIST: '/rental/scm/supplier/bankChannelList',
		OPERATION_SCALE_SAVE:'/rental/scm/supplier/operationScaleSave',
		ENTER:'/rental/scm/supplier/getAccountBalance',
		MERCHANT_SETTLE: '/rental/scm/supplier/merchantSettle',
		AUTH_URL: '/rental/scm/supplier/getAuthUrl',
		SEAL_AUTH_URL: '/rental/scm/supplier/getSealAuthUrl',
		AUTH_STATUS: '/rental/scm/supplier/getAuthStatus',
	},
  ACTIVES: {
    DIDI_SECTION: {
      LIST: '/rental/scm/selected/list'
    },
    TAKE_THE_LEAD : {
      LIST: '/rental/scm/grabTop/list',
      DETAIL: '/rental/scm/grabTop/detail',
      EDIT: '/rental/scm/grabTop/edit',
      UPDATE_STATUS: '/rental/scm/grabTop/status',
      STORE_LIST_BY_CITY: '/rental/scm/supplier/assembleCityStoreList',
    }
  },
  MARKETING_ACTIVITIES: {
    ACTIVITY_LIST: {
      SEARCH: '/rental/scm/action/list',
      DETAIL: '/rental/scm/action/detail',
      APPLY: '/rental/scm/supplier/enroll',
      UPDATE: '/rental/scm/supplier/enroll/update',
      EXIT: '/rental/scm/supplier/exit',
	  VEH_LIST: '/rental/scm/supplier/veh/mod/list',
	  CITY_LIST: '/rental/scm/supplier/city/list',
    }
  }
};
